/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from "react";
import { Card, ListGroup, Row, Col, Image } from "react-bootstrap";
import * as S from "./styles";
import { VApplication } from "../../../../application";
import { AppNavigatorService } from "../../../../services";

export interface IAuthorProps {
  image?: string;
  title?: string;
  description?: string;
  value?: string;
  link?: string;
}
const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};
export interface ITopAuthorsWidgetProps {
  title: string;
  authors?: IAuthorProps[];
  onRowClick?(author: IAuthorProps): any
}

const getFirstLetterOfEachWord = (text: any) => text?.match(/\b\w/g).join("");

export const TopAuthorsWidget = ({
  title,
  authors,
  onRowClick,
}: ITopAuthorsWidgetProps) => {
  const [role, setRole] = useState("");
  const appNavSrv = getAppNavService().whoAmI();
  console.log("author===>",authors)
  appNavSrv
    .then((resolvedValue: any) => {
      const UserRole = resolvedValue.whoami;
      setRole(UserRole);
    })
    .catch((error: any) => {
      console.error(error);
    });

  const _renderTitle = () => {
    if (title) {
      return (
        <Card.Header className="border-bottom">
          <h2 className="fs-5 fw-bold mb-0">{title}</h2>
        </Card.Header>
      );
    }
  };
  const _renderImageIf = (author: any) => {
    if (author?.image) {
      return (
        <Col xs="auto">
          <Card.Link href={author?.link ?? "#"} className="avatar-md">
            <Image rounded src={author?.image} className="m-0" />
          </Card.Link>
        </Col>
      );
    }
    if (author?.title) {
      return (
        <Col xs="auto">
          <Card.Link href={author?.link ?? "#"} className="avatar-md">
            <div
              className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary"
              style={S.AuthorImageStyle}
            >
              <span>{getFirstLetterOfEachWord(author?.title)}</span>
            </div>
          </Card.Link>
        </Col>
      );
    }
    return null;
  };
  const _renderProfileIf = (author: any) => {
    if (author?.title) {
      return (
        <Col xs="auto" className="px-0">
          <h4 className="fs-6 text-dark mb-0">
            <Card.Link href={author?.link ?? "#"}>
              {author?.title}
              {(author?.name===role) && (
                <Image
                  src="https://media4.giphy.com/media/llQMjpdCwjdrVGzz1d/giphy.gif"
                  width={30}
                  height={25}
                  style={{ paddingLeft: "8px" }}
                />
              )} 
            </Card.Link>
          </h4>
          {author?.description && <small>{author?.description}</small>}
        </Col>
      );
    }
  };
  const _renderValueIf = (author: any) => {
    if (author?.value) {
      return (
        <Col className="text-end">
          <span className="fs-6 fw-bolder text-dark">{author?.value}</span>
        </Col>
      );
    }
  };
  const _handleRowClick = (author: IAuthorProps) => {
    if (onRowClick) {
      onRowClick(author);
    }
  };
  const _renderCardBody = () => {
    if (authors) {
      return (
        <Card.Body className="py-0">
          <ListGroup className="list-group-flush">
            {authors?.map((author, index) => (
              <ListGroup.Item
                key={`author-item-${index}`}
                className="bg-transparent border-bottom py-3 px-0"
                onClick={_handleRowClick.bind(null, author)}
                style={{ cursor: "pointer" }}
              >
                <Row className="align-items-center">
                  {_renderImageIf(author)}
                  {_renderProfileIf(author)}
                  {_renderValueIf(author)}
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      );
    }
  };
  return (
    <Card border="0" className="shadow">
      {_renderTitle()}
      {_renderCardBody()}
    </Card>
  );
};

TopAuthorsWidget.defaultProps = {};
